import { createActions } from 'reduxsauce';

export const { Types: types, Creators: actions } = createActions({
    // view warehouse type
    requestViewWarehouseType: ['id'],
    viewWarehouseTypeSucceeded: ['data'],
    viewWarehouseTypeFailed: ['error'],

    // clear state
    clearWarehouseTypeViewState: null,
});

export default {
    // view warehouse type
    [types.REQUEST_VIEW_WAREHOUSE_TYPE]: (state) => ({
        ...state,
        view: {
            ...state.view,
            loading: true,
            error: null,
        },
    }),
    [types.VIEW_WAREHOUSE_TYPE_SUCCEEDED]: (state, { data }) => ({
        ...state,
        view: {
            ...state.view,
            typeDetails: data,
            loading: false,
        },
    }),
    [types.VIEW_WAREHOUSE_TYPE_FAILED]: (state, { error }) => ({
        ...state,
        view: {
            ...state.view,
            loading: false,
            error,
        },
    }),

    // clear state
    [types.CLEAR_WAREHOUSE_TYPE_VIEW_STATE]: (state) => ({
        ...state,
        view: {
            ...state.view,
            typeDetails: null,
        },
    }),
}
